<template>
  <div>
   <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">
            Documentos
            <strong>Rejeitados</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="showBox"> 
      <v-flex infoDados>    
         <div v-if="!this.documentosRejeitados">Nenhum documento obrigatório rejeitado.</div>

      <div
        class="p-t-20 boxFamilias"
        v-if="model.arquivoUploadSituacao == 1 || this.habilitacaoJuridicaRecusada || listaDocumentosSolicitacaoRejeitados.length > 0"
      >
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14" v-if=" model.tipFornecedor == 'J'">
                Habilitação
                <strong>Jurídica</strong>
              </h1>
              <h1 class="text-info font-size-14" v-if=" model.tipFornecedor == 'F'">
                Dados do
                <strong>Fornecedor</strong>
              </h1>
            </div>
          </v-flex>
        </v-layout>

        <v-flex inputIcon xs8 v-show="model.arquivoUploadSituacao == 1 ">
          <v-card class="card--flex-toolbar">
            <v-toolbar
              light
              height="60px"
              v-bind:class="{'item-aprovado':(model.arquivoUploadSituacao == 2),'item-reprovado':(model.arquivoUploadSituacao == 1)}"
            >
              <v-toolbar-title>
                <strong>{{ (model.tipFornecedor == 'J') ? $t('label.anexoContratoSocial') : $t('label.anexarDocumentoIdentidade') }}:</strong>
                <br />
                {{model.arquivoUpload}}
                <br />
                <strong>Motivo:</strong>
                {{model.motivoIndeferimentoStr}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
          <br />
        </v-flex>

        <v-flex xs8 v-if="this.habilitacaoJuridicaRecusada">
          <v-layout
            class="p-t-10 p-b-10"
            v-for="item in model.fornecedoresHabilitacaoJuridica"
            :key="item.cpfCnpj"  v-if="item.habilitacaoJuridicaSituacao==1"
          >
            <v-card class="card--flex-toolbar" >
              <v-toolbar
                light
                height="50px"                
                v-bind:class="{'item-reprovado':(item.habilitacaoJuridicaSituacao==1)}"
              >
                <v-toolbar-title>
                  <strong>{{(item.tipoCadastro=='D') ? $t('label.dirigente') : $t('label.socio')}} :</strong>
                  {{item.cpfCnpj}} - {{item.nome}}
                  <br />

                  <strong>Motivo:</strong>
                  {{item.motivoIndeferimentoStr}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-layout>
        </v-flex>

        <v-flex xs8 v-if="listaDocumentosSolicitacaoRejeitados.length > 0">
          <v-layout
            class="p-t-10 p-b-10"
            v-for="item in listaDocumentosSolicitacaoRejeitados" 
            :key="item.codDocumento" v-if="item.docSolicitacao.arquivoUploadSituacao==1"
          >
            <v-card class="card--flex-toolbar">
              <v-toolbar
                light
                height="60px"
                v-bind:class="{'item-aprovado':(item.docSolicitacao.arquivoUploadSituacao==2),'item-reprovado':(item.docSolicitacao.arquivoUploadSituacao==1)}"
              >
                <v-toolbar-title>
                  <strong>{{item.nomDocumento}}</strong>
                  <br />
                  <strong>Motivo:</strong>
                  {{item.nomMotivo}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-layout>
        </v-flex>
      </div>

      <div class="p-t-20 boxFamilias" v-if="listaFamiliaRejeitada.length > 0">
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                <strong>Família</strong>
              </h1>
            </div>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          class="p-t-10 p-b-10"
          v-for="item in listaFamiliaRejeitada"
          :key="item.codGrupo+''+item.familiaAssociada.codFamilia"
          v-if="item.familiaFornecSituacao==1"
        >
          <v-flex xs8>
            <v-card class="card--flex-toolbar">
              <v-toolbar
                light
                height="50px"
                v-bind:class="{'item-aprovado':(item.familiaFornecSituacao==2),'item-reprovado':(item.familiaFornecSituacao==1)}"
              >
                <v-toolbar-title>
                  <strong>{{item.familiaAssociada.codFamilia}}</strong>
                  - {{item.familiaAssociada.descFamilia}}
                  <br />
                  <strong>Motivo:</strong>
                  {{item.motivoIndeferimentoStr}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-flex>
        </v-layout>
      </div>

      <div class="p-t-20 boxFamilias" v-if="listaQualificacaoTecnicaRejeitada.length > 0">
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                Qualificação
                <strong>Técnica</strong>
              </h1>
            </div>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          class="p-t-10 p-b-10"
          v-for="item in listaQualificacaoTecnicaRejeitada"
          :key="item.codDocumento"
          v-if="item.qualificacaoTecnicaSituacao==1"
        >
          <v-flex xs8>
            <v-card class="card--flex-toolbar">
              <v-toolbar
                light
                height="50px"
                v-bind:class="{'item-aprovado':(item.qualificacaoTecnicaSituacao==2),'item-reprovado':(item.qualificacaoTecnicaSituacao==1)}"
              >
                <v-toolbar-title>
                  <strong>{{retornaNomeQualificacao(item.codDocumento)}}</strong>
                  <br />
                  <strong>Motivo:</strong>
                  {{item.motivoIndeferimentoStr}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-flex>
        </v-layout>
      </div>

      <div
        class="p-t-20 boxFamilias"
        v-if="listaRegularidadeRejeitada.length > 0 &&  enums.tipoDocumento !=null && modelCarregado"
      >
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                <strong>Regularidade</strong> Fiscal e Trabalhista
              </h1>
            </div>
          </v-flex>
        </v-layout>

        <div
          v-for="item in enums.tipoDocumento.filter(x=> listaRegularidadeRejeitada.find(y => x.valor == y.tipDocumento))"
          :key="item.chave+''+item.valor"
           v-if="tipoDocumento[item.chave]['regularidadeFiscTrabSituacao']==1"
        >
          <v-layout row wrap class p-b-20>
            <v-flex xs8>
              <v-card class="card--flex-toolbar">
                <v-toolbar
                  light
                  height="50px"
                  v-bind:class="{'item-aprovado':(tipoDocumento[item.chave]['regularidadeFiscTrabSituacao']==2),'item-reprovado':(tipoDocumento[item.chave]['regularidadeFiscTrabSituacao']==1)}"
                >
                  <v-toolbar-title>
                    <strong>{{item.descricao}}</strong>
                    <br />
                    <strong>Motivo:</strong>
                    {{listaRegularidadeRejeitada.find(r => item.valor == r.tipDocumento).motivoIndeferimentoStr}}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div
        class="p-t-20 boxFamilias"
        v-if="this.concordataSituacao == 1 || this.balancoSituacao == 1 || this.balancoSituacao2 == 1"
      >
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                <strong>Qualificação</strong> Econômico-Financeira
              </h1>
            </div>
          </v-flex>
        </v-layout>

        <v-flex inputIcon xs8 v-show="this.concordataSituacao == 1 ">
          <v-card class="card--flex-toolbar">
            <v-toolbar
              light
              height="60px"
              v-bind:class="{'item-aprovado':(model.concordataFalencia.arquivoUploadSituacao == 2),'item-reprovado':(model.concordataFalencia.arquivoUploadSituacao == 1)}"
            >
              <v-toolbar-title>
                <strong>Anexo do Documento - {{$t('label.concordataEFalencia')}}:</strong>
                <br />
                {{model.concordataFalencia.arquivoUpload}}
                <br />
                <strong>Motivo:</strong>
                {{model.concordataFalencia.motivoIndeferimentoStr}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-flex>
        <br />
        <v-flex inputIcon xs8 v-show="this.balancoSituacao == 1 ">
          <v-card class="card--flex-toolbar">
            <v-toolbar
              light
              height="60px"
              v-bind:class="{'item-aprovado':(model.balancoFinanceiro.arquivoUploadSituacao == 2),'item-reprovado':(model.balancoFinanceiro.arquivoUploadSituacao == 1)}"
            >
              <v-toolbar-title>
                <strong>Anexo do Documento - {{$t('label.balanco')}}:</strong>
                <br />
                {{model.balancoFinanceiro.arquivoUpload}}
                <br />
                <strong>Motivo:</strong>
                {{model.balancoFinanceiro.motivoIndeferimentoStr}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-flex>
        <v-flex inputIcon xs8 v-show="this.balancoSituacao2 == 1 ">
          <v-card class="card--flex-toolbar">
            <v-toolbar
              light
              height="60px"
              v-bind:class="{'item-aprovado':(model.balancoFinanceiro.arquivoUploadSituacao02 == 2),'item-reprovado':(model.balancoFinanceiro.arquivoUploadSituacao02 == 1)}"
            >
              <v-toolbar-title>
                <strong>Anexo do Documento - {{$t('label.balanco2')}}:</strong>
                <br />
                {{model.balancoFinanceiro.arquivoUpload02}}
                <br />
                <strong>Motivo:</strong>
                {{model.balancoFinanceiro.motivoIndeferimentoStr02}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-flex>
      </div>

      <div
        class="p-t-20 boxFamilias"
        v-if="listaUploadDeclaracaoRejeitada.length > 0 && enums.tipoUploadDeclaracao !=null && modelCarregado"
      >
        <v-layout row wrap>
          <v-flex p-t-30>
            <div class="tituloBox p-b-30 border-top">
              <div class="bg-primary barraTitulo"></div>
              <h1 class="text-info font-size-14">
                Formulários e
                <strong>Declarações</strong>
              </h1>
            </div>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          class="p-t-10 p-b-10"
          v-for="item in enums.tipoUploadDeclaracao.filter(x=> listaUploadDeclaracaoRejeitada.find(y => x.valor == y.tipDocumento) )"
          :key="item.chave"
           v-if="listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).uploadDeclaracaoSituacao==1"
        >
          <v-flex xs8>
            <v-card class="card--flex-toolbar">
              <v-toolbar
                light
                height="70px"
                v-bind:class="{'item-aprovado':(listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).uploadDeclaracaoSituacao==2),'item-reprovado':(listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).uploadDeclaracaoSituacao==1)}"
              >
                <v-toolbar-title>
                  <strong>{{item.descricao}}</strong>
                  <br />
                  {{listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).arquivoUpload}}
                  <br />
                  <strong>Motivo:</strong>
                  {{listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).motivoIndeferimentoStr}}
                  <br />
                
                </v-toolbar-title>
              
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
                 <div
  v-if="$verificaPerfilHabilitador() && listaUploadDeclaracaoRejeitada.find(r => item.valor == r.tipDocumento).tipDocumento == 150"
>
  <span style="display: inline-flex; align-items: center;">
    <v-icon small class="mr-1">account_box</v-icon>
    <strong>Termo Analisado por:</strong>&nbsp;{{ usuarioAnalistaTermo.nome }}
  </span>
</div>
          </v-flex>
        </v-layout>
      </div>
     </v-flex>
    </v-layout>
  </div>
</template>
<script>
import dominioService from "../../../services/dominioService";
import documentosFornecService from "../../../services/documentosFornecService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import usuarioService from "../../../services/usuarioService";

export default {
  name: "resumo-docs-rejeitados",
  mixins: [util],
  components: { /*Componentes utilizados*/ },
  props: { //Propriedades que o objeto recebe como parametro
  model: Object},
   created() { /*Metodo de start do componente*/
    dominioService.geEnums().then(response => {
    this.enums = response.data;
          if (this.model) {
        this.getFornecedor();
        usuarioService.getUsuariosHabilitador().then(response => {
          this.comboAnalistas = response.data;
       
          if (this.listaUploadDeclaracaoRejeitada && this.listaUploadDeclaracaoRejeitada.length > 0) {
            const docTermoRejeitado = this.listaUploadDeclaracaoRejeitada.find(
              (x) => x.tipDocumento == 150
            );
            if (docTermoRejeitado) {
              const idUsuario = docTermoRejeitado.idUsuarioValidTermo;
              this.usuarioAnalistaTermo = this.comboAnalistas.find(
                (analista) => analista.id == idUsuario
              );
            }
          }
        });
}
 });
 },
  watch: { //Propriedades assistidas
    model: {
      handler() {}
    }
  },
  data() {//Declaracao de variaveis
    return {
      showBox: true,
      valid:true,
      dialog: false,
      upload: {},
      arquivoFiplan: {},
      comboAnalistas: [],
      usuarioAnalistaTermo: Object,
      enums: Object,
      dominio: {
        categoria: [],
        paises: []
      },
      tipoDocumento: Object,
      listaFamiliaRejeitada: Object,
      listaQualificacaoTecnicaRejeitada: Object,
      listaRegularidadeRejeitada: Object,
      listaUploadDeclaracaoRejeitada: Object,
      listaDocumentosSolicitacaoRejeitados: Object,
      listaDocsQualificacaoTecnica: {},
      itemRejeitado: {},
      tipoCertificadoSelecionar: String,
      arrayFamiliasDocumento: [],
      modelCarregado: false
    };
  },
  computed: {//Campos computados

    documentosRejeitados() {
      //verificando se há algum documento rejeitado
      var docRejeitado = false;

      if (this.model != null) {
        if (
          this.model.arquivoUploadSituacao === 1 ||
          this.habilitacaoJuridicaRecusada ||
          this.listaFamiliaRejeitada.length > 0 ||
          this.listaRegularidadeRejeitada.length > 0 ||
          this.listaUploadDeclaracaoRejeitada.length > 0 ||
          this.listaQualificacaoTecnicaRejeitada.length > 0 ||
          this.listaDocumentosSolicitacaoRejeitados.length > 0 ||
          this.concordataSituacao === 1 ||
          this.balancoSituacao === 1 ||
          this.balancoSituacao2 === 1
        ) {
          docRejeitado = true;
          
        }
      }

      return docRejeitado;
    },
    habilitacaoJuridicaRecusada() {
      //verificando se algu mdocumento de habilitação juridica rejeitado
      var docRejeitado = false;
      if (this.model.fornecedoresHabilitacaoJuridica != null) {
        if (
          this.model.fornecedoresHabilitacaoJuridica.filter(
            x => x.habilitacaoJuridicaSituacao === 1
          ).length > 0
        )
          docRejeitado = true;
      }
      return docRejeitado;
    },
    concordataSituacao() {
      //verificando a situacao da concordata
      var situacao = 0;

      if (this.model != null) {
        if (this.model.concordataFalencia != null) {
          situacao = this.model.concordataFalencia.arquivoUploadSituacao;
        }
      }
      return situacao;
    },
    balancoSituacao() {
      //verificando a situacao do balanco
      var situacao = 0;

      if (this.model != null) {
        if (this.model.balancoFinanceiro != null) {
          situacao = this.model.balancoFinanceiro.arquivoUploadSituacao;
        }
      }
      return situacao;
    },
    balancoSituacao2() {
      //verificando a situacao do balanco
      var situacao = 0;

      if (this.model != null) {
        if (this.model.balancoFinanceiro != null) {
          situacao = this.model.balancoFinanceiro.arquivoUploadSituacao02;
        }
      }
      return situacao;
    }
  },
  methods: {//Declaracao de todos os metodos
    openBox() {
      this.showBox = !this.showBox;
    },
    getFornecedor() {
      //resgatando dados do fornecedor
          this.listaFamiliaRejeitada = this.model.familiaSolicitacao.filter(
            x => x.familiaFornecSituacao === 1
          );
          this.listaQualificacaoTecnicaRejeitada = this.model.qualificacaoTecnica.filter(
            x => x.qualificacaoTecnicaSituacao === 1
          );
          this.listaRegularidadeRejeitada = this.model.regularidadeFiscTrab.filter(
            x => x.regularidadeFiscTrabSituacao === 1
          );
          this.listaUploadDeclaracaoRejeitada = this.model.uploadDeclaracao.filter(
            x => x.uploadDeclaracaoSituacao === 1
          );

          this.getListaDocsQualificacaoTecnica();

          this.carregaRegularidade();
          this.getListaDocumentosSolicitacao();
          this.$removePreload(); /*Ocultar o PreLoad*/
    },
    carregaRegularidade() {
      //carregando dados de regularidade
      this.enums.tipoDocumento.filter(item => {
        var chave = item.chave;

        this.$set(this.tipoDocumento, chave, {
          tipDocumento: item.valor
        });

        var regularidadeFiscTrab = this.listaRegularidadeRejeitada.find(
          x => x.tipDocumento === item.valor
        );

        if (regularidadeFiscTrab) {
          this.$set(this.tipoDocumento, chave, regularidadeFiscTrab);
        }
      });
    },
    retornaNomeQualificacao(codDocumento) {
      //retorna o nome da qualificacao
      var nome = "";
      if (this.listaDocsQualificacaoTecnica.length > 0) {
        nome = this.listaDocsQualificacaoTecnica.find(
          r => codDocumento === r.codDocumento
        ).nomDocumento;
        nome +=
          this.listaDocsQualificacaoTecnica.find(
            r => codDocumento === r.codDocumento
          ).exigido === "S"
            ? "- Exigível"
            : "- Elegível";
      }

      return nome;
    },
    retornaEnumDescricao(_enum, valor) {
      //retornar a descrição do enum
      if (!valor || !this.enums[_enum]) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao : null;
    },
    getListaDocsQualificacaoTecnica() {
      //resgata a lita de qualificacao tecnica
      dominioService
        .getListaDocsQualificacaoTecnica(this.model.familiaSolicitacao)
        .then(response => { /*resposta do servico*/
          this.listaDocsQualificacaoTecnica = response.data; /*dados de retorno*/
          this.fn_DocPorFamilia();
          this.modelCarregado = true;
        });
    },

    fn_DocPorFamilia() {
      //verificar documento por familia
      this.arrayFamiliasDocumento = [];

      this.model.familiaSolicitacao.forEach(item => {
        this.arrayFamiliasDocumento.push({
          idFamiliaFornec: item.idFamiliaFornec,
          descFamilia: item.familiaAssociada.descFamilia,
          codGrupo: item.codGrupo,
          numFamilia: item.numFamilia,
          documentos: this.listaDocsQualificacaoTecnica.filter(
            x => x.codGrupo === item.codGrupo && x.numFamilia === item.numFamilia
          )
        });
      });
    },

     getListaDocumentosSolicitacao() {
      //resgata a lita de documentos da habilitação jurica/Documento da solicitação
      let docsSolicitacao = [];

      documentosFornecService
        .getDocumentosFornecedorSolicitacao(this.model.idFornecSolicitacao)
        .then(response => { /*resposta do servico*/
          let docsSolicitacao = response.data; /*dados de retorno*/

          this.listaDocumentosSolicitacaoRejeitados = docsSolicitacao.filter(
              x => x.docSolicitacao.arquivoUploadSituacao === 1
            );     
            this.modelCarregado = true;
        });
    },
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.v-list__tile {
  height: 60px;
}

.v-list__tile__sub-title {
  font-size: 11px;
}

.v-list__tile--active {
  font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
  color: #333;
}
.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}

.tipoItem {
  padding-top: 0;
}
.boxFamilias .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
}
</style>